import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: { label: string; to: string };
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        align === "center" ? "md:flex-col md:items-center text-center" : "md:justify-between"
      }`}
    >
      <div className={align === "center" ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? (
          <div
            className={`mb-3 flex items-center gap-3 ${
              align === "center" ? "justify-center" : ""
            }`}
          >
            <span className="h-px w-8 bg-accent-500/70" />
            <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-400">
              {eyebrow}
            </span>
          </div>
        ) : null}
        <h2 className="font-heading text-2xl text-foreground-50 md:text-[32px] md:leading-tight">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-400 md:text-[15px]">
            {desc}
          </p>
        ) : null}
      </div>
      {action ? (
        <Link
          to={action.to}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-accent-400"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
        </Link>
      ) : null}
    </div>
  );
}